import {Component, HostBinding, Input} from '@angular/core';
import {UserDTO} from '@tj/tj-dmp-lib-api';

/**
 * Avatar with the user's initials, on a background whose hue is derived from the login: a user keeps the same
 * color everywhere (header, account page…). Lightness is fixed in the SCSS.
 */
@Component({
    selector: 'dmp-user-avatar',
    template: '<p-avatar [label]="initials" [size]="size" shape="circle"></p-avatar>',
    styleUrls: ['./user-avatar.component.scss'],
    standalone: false
})
export class UserAvatarComponent {
    @Input({required: true}) user: Pick<UserDTO, 'login' | 'firstName' | 'lastName'>;
    @Input() size: 'normal' | 'large' | 'xlarge' = 'normal';

    get initials(): string {
        const {firstName, lastName, login} = this.user;
        const initials = firstName && lastName ? firstName.charAt(0) + lastName.charAt(0) : login.charAt(0);
        return initials.toUpperCase();
    }

    @HostBinding('style.--avatar-hue')
    get hue(): number {
        let hue = 0;
        for (const char of this.user.login) {
            hue = (hue * 31 + char.charCodeAt(0)) % 360;
        }
        return hue;
    }
}
